export function buildFormData(data) {
    return Object.entries(data)
        .filter(([_, value]) => value != null && value !== "")
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');
}